const DATASTORE_ENDPOINT =
  process.env.REACT_APP_DATASTORE_ENDPOINT ||
  'https://datastore.tanantech.co.uk/1.0/data';

const DATASTORE_WEB_FORM_ID =
  process.env.REACT_APP_DATASTORE_WEB_FORM_ID ||
  'mot';

const IS_TEST_ENVIRONMENT = (() => {
  const hostname = window.location.hostname;
  return hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('dev.') ||
    hostname.startsWith('release.');
})();

const CAR_FINANCE_BACKEND_URL = (() => {
  if (process.env.REACT_APP_CAR_FINANCE_BACKEND_URL) return process.env.REACT_APP_CAR_FINANCE_BACKEND_URL;
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return 'https://dev.app.claims1.co.uk';
  if (hostname.startsWith('dev.')) return 'https://dev.app.claims1.co.uk';
  if (hostname.startsWith('release.')) return 'https://release.app.claims1.co.uk';
  return 'https://app.claims1.co.uk';
})();

const KOUNT_DECISION_ENDPOINT =
  process.env.REACT_APP_KOUNT_DECISION_ENDPOINT ||
  `${CAR_FINANCE_BACKEND_URL}/api/public/kount/new-account-opening`;

const DEFAULT_KOUNT_FALLBACK_MOBILE = '07123456789';

const KOUNT_IS_SPA = process.env.REACT_APP_KOUNT_IS_SPA !== 'false';

export {
  DATASTORE_ENDPOINT,
  DATASTORE_WEB_FORM_ID,
  CAR_FINANCE_BACKEND_URL,
  KOUNT_DECISION_ENDPOINT,
  DEFAULT_KOUNT_FALLBACK_MOBILE,
  IS_TEST_ENVIRONMENT,
  KOUNT_IS_SPA,
};
